module.exports = __webpack_public_path__ + "static/media/torte.e029c0cd.svg";